'use strict';

import controller from './equipo-minimo.controller';
import template from './equipo-minimo.html';

const EquipoMinimoComponent = {
  bindings: {
    equipo: '='
  },
  controller,
  template
};

export default EquipoMinimoComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/equipo-minimo/equipo-minimo.component.js